import * as React from 'react';
import './App.css';
import _ from 'lodash';

import Document from "./Document"
import Block from "./Block"

import ErrorBoundary from "./ErrorBoundary"

import { DragDropContext, DropTargetSpec, DropTargetConnector, DropTargetMonitor, DropTarget } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'

import * as actions from '../actions'

import { saveFile } from "../lib/saveFile"

import { docAtom, network, documentC } from '../globals'
import { NetworkProvider } from 'golgi'

import * as Model from '../types/document'
import { propsChanged } from 'src/util';
import CustomDragLayer from 'src/view/CustomDragLayer';
import TopMenu from 'src/view/TopMenu';
import { HoveredNodeState } from 'src/view/HoveredNodeContext';
import { FILE } from 'react-dnd-html5-backend/lib/NativeTypes';
import { fixDocument } from 'src/model/document';

import exampleNormalize from "../examples/normalize.json"
import exampleSynonymsBlank from "../examples/synonyms blank.json"
import exampleSynonymsPlus from "../examples/synonyms plus.json"
import exampleVis from "../examples/vis.json"
import exampleNamesBlank from "../examples/names blank.json"
import exampleSynonyms from "../examples/synonyms.json"
import exampleSquareRoots from "../examples/square roots.json"

const examples: Array<{name: string, document: Model.Document}> = [
  {name: "normalize", document: exampleNormalize as any},
  {name: "names (blank)", document: exampleNamesBlank as any},
  {name: "synoynyms (plus)", document: exampleSynonymsPlus as any},
  {name: "vis", document: exampleVis as any},
  {name: "empty", document: {definitions: [], scratch: actions.makeNewBlock()}},
  {name: "synonyms", document: exampleSynonyms as any},
  {name: "square roots", document: exampleSquareRoots as any},
  {name: "synonyms (blank)", document: exampleSynonymsBlank as any},

]


export let globalApp: App

const catchErrors = true

class App extends React.Component<ReturnType<typeof dropCollect>> {
  history = [] as Array<Model.Document>

  constructor(props: ReturnType<typeof dropCollect>) {
    super(props)

    globalApp = this
    ;(window as any).globalApp = this

    this.setDocument(this.getDocumentFromLocalStorage())
    // docAtom.set(exampleVector2)
    // docAtom.set(exampleSwitches2 as any as Model.Document)

    window.addEventListener('storage', (e) => {
      docAtom.set(this.getDocumentFromLocalStorage())
    })

    document.addEventListener('keyup', this.onDocumentKeyUp, false);  
  }

  getDocumentFromLocalStorage(): Model.Document {
    let document: Model.Document
    const documentString = localStorage.getItem('document')
    if (documentString) {
      document = JSON.parse(documentString)
    } else {
      document = {definitions: [], scratch: actions.makeNewBlock()}  // default
    }
    document = fixDocument(document)
    return document
  }

  setDocument(document: Model.Document) {
    const fixedDocument = fixDocument(document)
    docAtom.set(fixedDocument)
  }

  undo() {
    if (this.history.length <= 1) { return }
    const current = this.history.pop()  // pop current
    const last = this.history.pop()  // pop last
    docAtom.set(last!)  // it'll get reinserted by onDocAtomRenderChange; dumb huh?
  }

  onDocumentKeyUp = (e: KeyboardEvent) => {
    if (e.key === 'z') {
      console.log("z", e)
      if ((e.ctrlKey || e.metaKey)) {
        console.log("detected ctrl-z")
        this.undo()
      }
    }
  }

  onDocAtomRenderChange = (document: Model.Document) => {
    // console.log('onDocAtomRenderChange', document)
    localStorage.setItem('document', JSON.stringify(document))
    this.history.push(document)
    this.forceUpdate()
  }

  onError = (error: Error, errorInfo: React.ErrorInfo) => {
    console.log("ERROR", error)
    console.log("STACK", errorInfo.componentStack)
    alert("Error detected; undoing")
    this.undo()
  }

  render() {
    const { connectDropTarget } = this.props
    const document = docAtom.get()

    let toRender = 
      connectDropTarget(<div className="App">
        <CustomDragLayer />
        <Block right={
          <div className="App-header">
            {/* <h1>PANE</h1> */}
            <div>
              <input
                value={document.name || ""}
                onChange={(e) => actions.act(() => {
                  documentC._('name').set(e.target.value)
                })} />
              <button onClick={() => saveFile(JSON.stringify(document), (document.name || "PANE") + ".json", "application/json;charset=utf-8")}
                      style={{fontSize: "130%", marginLeft: 20}}>
                Save
              </button>
            </div>
            <div>
              {examples.map(({name, document}) =>
                <button key={name} onClick={() => this.setDocument(document)}>{name}</button>
              )}
            </div>
          </div>
        } />
        <NetworkProvider network={network} propsChanged={propsChanged}>
          <div style={{display: 'flex'}}>
            <HoveredNodeState>
              <Document documentC={documentC}/>
            </HoveredNodeState>
            <div style={{color: 'white', whiteSpace: 'nowrap'}}>
              -------------------------------------------------------
            </div>
          </div>
          <TopMenu documentC={documentC}/>
        </NetworkProvider>
      </div>)
    
    if (catchErrors) {
      toRender = <ErrorBoundary onError={this.onError}>{toRender}</ErrorBoundary>
    }

    return toRender
  }

  componentDidMount() {
    docAtom.onBatchedChange('render', this.onDocAtomRenderChange)

    this.renderLoop()
  }

  renderLoop = () => {
    this.forceUpdate()
    requestAnimationFrame(this.renderLoop)
  }
}


const dropSpec: DropTargetSpec<{}> = {
  drop(props, monitor, component) {
    const files = monitor.getItem().files as Array<File>
    if (files.length === 1) {  
      const reader = new FileReader()
      reader.onloadend = () => {
        const text = reader.result as string
        component.setDocument(JSON.parse(text))
      }
      reader.readAsText(files[0])
    }
  }
}

function dropCollect(connect: DropTargetConnector, monitor: DropTargetMonitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}


export default (
  DragDropContext(HTML5Backend)(
    DropTarget(FILE, dropSpec, dropCollect)(
      App)))



// WEBPACK FOOTER //
// ./src/view/App.tsx